import { PatientSimple, PatientSimpleQuery } from '@dreryk/egabinet-patient-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { LoaderSpinner } from '@dreryk/react-components';
import { Slot } from '@dreryk/watermelon';

type CalendarPatientSectionLoaderRenderer = (renderProps: { patient: PatientSimple }) => JSX.Element;

type CalendarPatientSectionLoaderProps = {
   readonly children: CalendarPatientSectionLoaderRenderer;
   readonly patientId: number;
};

export const CalendarPatientSectionLoader = (props: CalendarPatientSectionLoaderProps): JSX.Element | null => {
   const { data: patient, loading: patientLoading, error: patientError } = useCqrsGet<PatientSimple>(() => {
      const query = new PatientSimpleQuery();
      query.id = Slot.of(props.patientId);
      return query;
   });

   if (patientLoading) {
      return <LoaderSpinner />;
   }

   if (patientError) {
      return null;
   }

   return props.children({
      patient: patient,
   });
};
